<agpr-dialog-container
    [id]="'listPickerDialog'"
    [showClose]="true"
    [heading]="header"
    (close)="closeDialog(null)"
    [ngClass]="{'agpr-listPicker-dialog-addMode': addMode, 'agpr-listPicker-dialog-selectMode': !addMode }"
    [agprLoading]="loading"
    [agprGlobalLoading]="true"
>
    <div class="agpr-listPicker">
        <div class="agpr-listPicker-lhp">
            <div class="agpr-listPicker-filter">
                <!-- autocomplete used here for custom "Create list [listname]" option -->
                <agpr-autocomplete
                    [ngClass]="{'agpr-listPicker-filter-input': !addMode}"
                    #autocomplete
                    [id]="id + '.filterTextInput'"
                    (clear)="resetLists()"
                    labelField="name"
                    ariaLabel="Discover.listBuilder.dialog.filterPlaceholder"
                    (searchStringChanged)="filterRows($event)"
                    [customOptions]="listsAutocompleteOptions"
                    [clearOnBlur]="false"
                    placeholder="Discover.listBuilder.dialog.filterPlaceholder"
                >
                </agpr-autocomplete>
            </div>
            <span *ngIf="!addMode" class="agpr-listPicker-selectChipContainer">
                <agpr-chip-container
                    [id]="id + '.selectListSummary'"
                    [chips]="workingListsChips"
                    (removeChip)="removeChip($event)"
                >
                </agpr-chip-container>
            </span>
            <div class="agpr-listPicker-newListButton">
                <agpr-button
                    [label]="'Discover.listBuilder.dialog.button.createList' | localize"
                    (click)="createNewList()"
                    [style]="buttonTypes.tertiary"
                    class="agpr-listPicker-newListButton"
                >
                </agpr-button>
            </div>
            <agpr-scroll-panel class="agpr-listPicker-scrollpanel">
                <agpr-table
                    id="listPickerTable"
                    class="agpr-listPicker-table"
                    [columns]="columnDefs"
                    [sortColumn]="nameColumn"
                    [showDelete]="false"
                    [sortAscending]="true"
                    [(ngModel)]="filteredRows"
                    (itemChanged)="selectionChanged($event)"
                    (allSelectedChanged)="selectAllChanged($event)"
                    [vsItemSize]="37"
                    [vsMinBufferPx]="500"
                    [vsMaxBufferPx]="500"
                >
                </agpr-table>
            </agpr-scroll-panel>
        </div>
        <div *ngIf="addMode" class="agpr-listPicker-rhp">
            <agpr-message
                [severity]="messageSeverityEnum.info"
                [id]="id + '.selectedBanner'"
            >
                <span
                    class="agpr-listPicker-bold"
                >
                    {{ selectedCount }}
                </span>
                {{ 'Discover.listBuilder.dialog.selectedBanner' | localize }}
            </agpr-message>

            <agpr-panel
                class="agpr-listPicker-panel"
                [contentPadding]="false"
                [toggleable]="false"
            >
            </agpr-panel>
            <agpr-scroll-panel class="agpr-listPicker-listSummary">
                <agpr-chip-container
                    class="agpr-listPicker-chipContainer"
                    [id]="id + '.listSummary'"
                    [chips]="workingListsChips"
                    [plainMode]="true"
                    (removeChip)="removeChip($event)"
                ></agpr-chip-container>
                <agpr-message
                    *ngIf="workingListsChips.length === 0"
                    class="agpr-listPicker-listSummary-noContent"
                    [severity]="messageSeverityEnum.noContent"
                >
                    {{ 'Discover.listBuilder.dialog.listSummary.noContent' | localize }}
                </agpr-message>
                <div
                    *ngIf="addMode && showListBuilderCheckbox && workingListsChips.length > 0"
                    class="agpr-listPicker-selectCheckbox"
                >
                    <agpr-checkbox
                        id="listPicker_addListToBuilder"
                        label="Discover.listBuilder.dialog.selectListsCheckbox"
                        [binary]="true"
                        [(ngModel)]="addToListBuilder"
                        infoCircleTooltip="Discover.listBuilder.dialog.addToListBuilderMessage"
                    ></agpr-checkbox>
                </div>
            </agpr-scroll-panel>
        </div>
    </div>


    <ng-template #footerLeft>
        <agpr-button
            [label]="'cancel' | localize"
            (click)="closeDialog(null)"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            *ngIf="addMode"
            [style]="buttonTypes.primary"
            label="Discover.listBuilder.dialog.button.updateButton"
            [disabled]="workingListsChips.length === 0"
            (click)="updateLists()"
        >
        </agpr-button>
        <agpr-button
            *ngIf="!addMode"
            [style]="buttonTypes.primary"
            label="Discover.listBuilder.dialog.button.selectButton"
            (click)="selectLists()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>

<ng-template let-row="row" let-column="column" #countInfoCell>
    <div class="agpr-listPicker-table-row">
        <label
            *ngIf="row.count !== null && !row.countLoading"
            class="agpr-listPicker-table-label"
        >
            {{row.count}}
        </label>
        <span>
            <span
                *ngIf="row.modifiedUser"
                role="img"
                class="fa-regular fa-circle-info agpr-listPicker-infoCircle"
                [agprTooltip]="'Tags.manageDialog.tagGroupInformation' | localize : {
                    createdDate: row.createdDate,
                    createdBy: row.createdUser,
                    modifiedDate: row.modifiedDate,
                    modifiedBy: row.modifiedUser
                }"
                [initiallyFocusable]="false"
            ></span>
            <span
                *ngIf="!row.modifiedUser"
                role="img"
                class="fa-regular fa-circle-info agpr-listPicker-infoCircle"
                [agprTooltip]="'Tags.manageDialog.tagGroupInformation.unmodified' | localize : {
                    createdDate: row.createdDate,
                    createdBy: row.createdUser
                }"
                [initiallyFocusable]="false"
            ></span>
        </span>
    </div>
</ng-template>
